//@ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');
//@ constants
const { EURO_TEXT } = require('constants/index');
const actionTypes = require('constants/actionTypes');
const { CREDIT_CARD_REVOLVING_PROCESS, NOT_ALLOWED_NEW_CREDITCARD_PAYMENT_METHOD_CHANGE_COUNTRIES } = require('constants/flagBasedFeatures');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const hireCardCreditINE = require('actions/commons/hireCardCreditINE');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { formatText } = require('core/i18n').i18n;

const setMethod = method => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_METHOD,
    payload: { method }
});

const setInstallments = installments => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_INSTALLMENTS,
    payload: { installments }
});

const setVisibleStep = step => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_SET_VISIBLE_STEP,
    payload: { step }
});

const setDisabledButton = value => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_SET_DISABLED_BUTTON,
    payload: {
        value,
    }
});
const setProduct = product => ({
    type: actionTypes.CARD_CHANGE_NEW_PAYMENT_METHOD_SET_PRODUCT,
    payload: {
        product,
    }
});
const validateStep = (step, valid) => (dispatch, getState) => {
    const isRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    dispatch({
        type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_VALIDATE_STEP,
        payload: {
            step,
            isRevolving,
            valid
        }
    });
};

const setAgreementCheckbox = evt => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_SET_AGREEMENT_CHECKBOX,
    payload: {
        checked: evt.target.checked
    }
})

const setWillCancel = willCancel => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_WILL_CANCEL,
    payload: { willCancel }
});

const clearRequest = () => ({ type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_CLEAR });

const successChange = payload => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_SUCCESS,
    payload
});

const failureChange = error => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_FAILURE,
    payload: { error }
});

const requestChange = () => ({ type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_REQUEST });

const getPaymentMethodInformationRequest = () => ({
    type: actionTypes.CARD_GET_PAYMENT_METHOD_INFORMATION_REQUEST
});

const getPaymentMethodInformationFailure = error => ({
    type: actionTypes.CARD_GET_PAYMENT_METHOD_INFORMATION_FAILURE,
    payload: { error }
});

const getPaymentMethodInformationSuccess = (response, cardLimit, newFlow) => ({
    type: actionTypes.CARD_GET_PAYMENT_METHOD_INFORMATION_SUCCESS,
    payload: {
        response,
        cardLimit,
        newFlow
    }
});
const setCardId = cardId => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_SET_CARD_ID,
    payload: { cardId }
});
const processEmailLoading = () => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_PROCESS_EMAIL_LOADING
});
const processEmailSuccess = () => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_PROCESS_EMAIL_SUCCESS
});
const processEmailError = () => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_PROCESS_EMAIL_ERROR
});
const agreeCheckboxCC = agreeCheckboxPaymentMethod => ({
    type: actionTypes.HIRE_CARD_CREDIT_CARD_AGREECHECKBOXCC,
    payload: {
        agreeCheckboxPaymentMethod,
    },
});
const onHandleChangeCheckBoxCC = () => ({
    type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_AGREEMENT_CHECKBOX_CC,
});
const postChange = cardId => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCardChangeNewPaymentMethod = getState().cardChangeNewPaymentMethod
        const immHirePaymentMethod = getState().hirePaymentMethod
        const documentIdPolicy = immCardChangeNewPaymentMethod.get('documentIdPolicy')

        const immCardChangePaymentMethod = getState().cardChangeNewPaymentMethod.get('steps').get('0');
        const immCard = getState().cards.get('byId').get(cardId);
        const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        const contractNumberAccount = immCard.getIn(['contract', 'number']);
        const contractNumber = immCard.get('fullContractNumber')
        let acceptanceText;
        if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
            acceptanceText = 'NA'
        }
        if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
            acceptanceText = formatText('hireCardOpenCreditStepINE-titlePdf')
        }
        if (!__CONTACT_CENTER__) {
            acceptanceText = formatText('hireCardOpenCreditStepPolicy-titlePdfWP')
        }

        const requestData = {
            header: {
                version: 2,
            },
            query: {
                dataToken,
                documentId: documentIdPolicy,
                operationProcessId: immCardChangeNewPaymentMethod.get('operationProcessIdInitPolicy'),
                scrollDown: immCardChangeNewPaymentMethod.get('scrollDownPolicy'),
                codigoMercado: immCardChangePaymentMethod.get('marketCode'),
                codigoMercadoOculto: immCardChangePaymentMethod.get('hiddenMarketCode'),
                contractNumber,
                contratoTarjeta: {
                    numerodecontrato: contractNumberAccount,
                    producto: immCard.getIn(['contract', 'product'])
                },
                estandarDeReferencia: immCardChangePaymentMethod.get('referenceStandard').toJS(),
                estandarReferenciaOculto: immCardChangePaymentMethod
                    .get('referenceStandard')
                    .toJS(),
                formaDePagoActual: immCardChangePaymentMethod.get('currentPaymentMethod'),
                formaDePagoNueva: immHirePaymentMethod.get('type'),
                idRangoFP: immCardChangePaymentMethod.get('newIdRango'),
                importeCuota: {
                    divisa: EURO_TEXT,
                    importe: immHirePaymentMethod.get('value')
                },
                modalidadFormaPagoActual: immCardChangePaymentMethod.get('currentPaymentMode'),
                modalidadFormaPagoOculto: immCardChangePaymentMethod.get(
                    'hiddenCurrentPaymentMode'
                ),
                tipoLiquidacionActual: immCardChangePaymentMethod.get('currentSettlementType'),
                tipoLiquidacionNueva: immCardChangePaymentMethod.get('newSettlementType'),
                acceptanceText,
                scrollDown: __CONTACT_CENTER__ && !isPrintOfficeMode() || !__CONTACT_CENTER__ ? true : false
            }
        };

        dispatch(requestChange());
        APIPost({ dispatch, endpoint: 'cardChangePaymentMethodConfirmation', params: requestData })
            .then(response => {
                dispatch(successChange(response))
                if (showIneAndRevolving) {
                    const termsAndsCondsHiringData = [
                        {
                            standard: immCard.getIn(['product', 'standard']),
                            subType: immCard.getIn(['product', 'subtype']),
                            type: immCard.getIn(['product', 'type'])
                        }
                    ];
                    dispatch(setTermsAndCondsInfoRevolving(immCard.get('standarAlias'), termsAndsCondsHiringData, contractNumber));
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(failureChange(response.error));
                } else {
                    throw response;
                }
            });
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const requestPaymentMethodInfo = cardId => (dispatch, getState) => {
    const immCard = getState().cards.get('byId').get(cardId);
    const immFlagBasedFeatures = getState().flagBasedFeatures;

    const newCreditCardsMethodFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDITCARD_PAYMENT_METHOD_CHANGE_COUNTRIES);

    const cardLimit = immCard.getIn(['limit', 'amount']);
    const requestData = {
        query: {
            producto: immCard.getIn(['contract', 'product'], ''),
            numeroContrato: immCard.getIn(['contract', 'number'], '')
        }
    };
    dispatch(getPaymentMethodInformationRequest());
    return APIGet({ dispatch, endpoint: 'cardChangePaymentMethod', params: requestData })
        .then(response => dispatch(getPaymentMethodInformationSuccess(response, cardLimit, newCreditCardsMethodFF)))
        .then(() => dispatch(setCardId(cardId)))
        .catch(response => {
            if (!!response.error) {
                dispatch(getPaymentMethodInformationFailure(response.error));
            } else {
                throw response;
            }
        });
};
const validateINEDIRStep = step => (dispatch, getState) => {

    const immCardChangePaymentMethod = getState().cardChangeNewPaymentMethod;
    const immCards = getState().cards;
    const cardId = immCardChangePaymentMethod.get('cardId');
    const immCard = getState().cards.get('byId').get(cardId);
    const documentINE = immCardChangePaymentMethod.get('initialDocumentsList');
    const contractNumberAccount = immCard.get('fullContractNumber')
    const contractNumber = immCard.get('associatedAccount')
    const product = {
        type: immCard.getIn(['contract', 'product'], ''),
        standard: immCardChangePaymentMethod.getIn(['steps', 0, 'referenceStandard', 'codigodeestandar']),
        subtype: immCardChangePaymentMethod.getIn(['steps', 0, 'referenceStandard', 'subtipodeproducto', 'subtipodeproducto']),
        cardId,
        contractNumber,
        contractNumberAccount,
        processType: "precontractual_payment_change",
        amount: immCard.getIn(['limit', 'amount'])
    }
    const documentINESize = documentINE.size < 2
    const getInitINEDIRstep = hireCardCreditINE.getInitINEDIRstep(immCards, product)
    dispatch(validateStep(step));
    if (__CONTACT_CENTER__) {
        dispatch(getInitINEDIRstep).then(() => {
            dispatch(validatePolicyStep());
        })
    } else {
        return documentINESize && dispatch(getInitINEDIRstep);
    }
};
const processEmail = (step) => (dispatch, getState) => {
    const immCardChangePaymentMethod = getState().cardChangeNewPaymentMethod;

    const cardId = immCardChangePaymentMethod.get('cardId');
    const immCard = getState().cards.get('byId').get(cardId);
    const productType = immCard.getIn(['product', 'type'])
    const productSubType = immCard.getIn(['product', 'subtype'])
    const standard = immCard.getIn(['product', 'standard'])

    const documentId = immCardChangePaymentMethod.get('documentId')
    const operationProcessIdInit = immCardChangePaymentMethod.get('operationProcessIdInit')
    const contractNumber = immCard.get('fullContractNumber')

    let acceptanceText;
    if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
        acceptanceText = 'NA'
    }
    if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
        acceptanceText = formatText('hireCardOpenCreditStepINE-titlePdf')
    }
    if (!__CONTACT_CENTER__) {
        acceptanceText = formatText('hireCardOpenCreditStepINE-labelCheckbox')
    }

    const documentIdDIR = immCardChangePaymentMethod.get('documentIdDIR')

    const params = {
        query: {

            product: {
                type: productType,
                subtype: productSubType,
                standard: standard
            },
            contactCenter: false,
            sendInsuranceDocument: true,
            sendRelevantRevolvingDocument: false,
            documentId,
            contractNumber,
            mailType: "precontractual_payment_change",
            operationProcessId: operationProcessIdInit,
            acceptanceText,
            documents: [
                {
                    documentId: immCardChangePaymentMethod.get('documentIdINE'),
                    scrollDown: __CONTACT_CENTER__ && !isPrintOfficeMode() ? false : true,
                },
                ...(documentIdDIR ? [{
                    documentId: documentIdDIR,
                    scrollDown: __CONTACT_CENTER__ && !isPrintOfficeMode() ? false : true,
                }] : [])
            ],
        }
    };
    dispatch(processEmailLoading());

    return APIPost({
        dispatch,
        endpoint: 'hiringCardsSimple',
        params
    })
        .then(() => {
            dispatch(validateStep(step, true));
            dispatch(processEmailSuccess());

        })
        .catch(response => {
            if (!!response.error) {
                dispatch(processEmailError());
            }
        });
};

const validatePolicyStep = () => (dispatch, getState) => {
    const immCardChangePaymentMethod = getState().cardChangeNewPaymentMethod;
    const cardId = immCardChangePaymentMethod.get('cardId');
    const immCard = getState().cards.get('byId').get(cardId);
    const immCardChangeNewPaymentMethod = getState().cardChangeNewPaymentMethod;
    const documentPolicy = immCardChangeNewPaymentMethod.get('documentPolicy')
    const contractNumberAccount = immCard.get('fullContractNumber')
    const contractNumber = immCard.get('associatedAccount')
    const product = {
        type: immCard.getIn(['contract', 'product'], ''),
        standard: immCardChangePaymentMethod.getIn(['steps', 0, 'referenceStandard', 'codigodeestandar']),
        subtype: immCardChangePaymentMethod.getIn(['steps', 0, 'referenceStandard', 'subtipodeproducto', 'subtipodeproducto']),
        cardId,
        contractNumber,
        contractNumberAccount,
        processType: "contract_payment_change",
        amount: immCard.getIn(['limit', 'amount'])
    }
    !documentPolicy && dispatch(hireCardCreditINE.getInitPolicystep(immCardChangeNewPaymentMethod, product));
};
const validateStepThree = step => (dispatch, getState) => {

    const policyDocument = getState().cardChangeNewPaymentMethod.get('documentPolicy');
    !policyDocument && dispatch(processEmail(step)).then(() => {
        dispatch(validatePolicyStep());
    });

    policyDocument && dispatch(validateStep(step, true));

};
const getStep = step => (dispatch, getState) => {
    const valid = getState().cardChangeNewPaymentMethod.getIn(['steps', step - 1, 'valid']);
    if (!valid) {
        scrollToTop();
    }
    return valid;
};
const newValidateStep = step => (dispatch, getState) => {
    switch (step) {
        case 1:
            dispatch(validateINEDIRStep(step));
            break;
        case 2:
            dispatch(validateStepThree(step));

            break;
        default:
            break;
    }


    return dispatch(getStep(step));
};


module.exports = {
    setAgreementCheckbox,
    setMethod,
    setInstallments,
    setVisibleStep,
    setDisabledButton,
    validateStep,
    setWillCancel,
    postChange,
    clearRequest,
    requestPaymentMethodInfo,
    newValidateStep,
    setProduct,
    agreeCheckboxCC,
    onHandleChangeCheckBoxCC,
    processEmail
};
